export {ShortcutComponent} from './shortcut.component';



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/shortcut/index.ts